import { render } from "./LocalRegistration.vue?vue&type=template&id=e08097f0&ts=true"
import script from "./LocalRegistration.vue?vue&type=script&lang=ts"
export * from "./LocalRegistration.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__